<template>
  <div class="option-list">
    <div class="selected-option"
      @click.stop="showOptionList"
    >
      <span>{{ placeholder }}: {{ selectedOptions.join(' ') }}</span>
<!--      <img :src="require('@/assets/option-list-arr.svg')" />-->
    </div>
    <div class="options" ref="options" v-show="openOptionList">
      <div class="options-item"
        v-for="(option, index) in options"
        :key="index"
      >
        <v-checkbox
          v-model="selectedOptions"
          :value="option.value"
          :label="option.name"
          @change="selectOption(option)"
        >
        </v-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionList',
  props: {
    value: {
      type: Array,
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    selectedOptions: [],
    openOptionList: false,
  }),
  mounted() {
    this.selectedOptions = this.value;
    window.addEventListener('click', this.hideOptionList);
  },
  methods: {
    hideOptionList(e) {
      if (this.openOptionList && !e.target.closest('.options')) {
        this.openOptionList = false;
      }
    },
    showOptionList() {
      this.openOptionList = true;
    },
    selectOption() {
      this.$emit('selectOption', this.selectedOptions);
    },
  },
  destroyed() {
    window.removeEventListener('click', this.hideOptionList);
  },
};
</script>

<style  lang="scss">
.option-list {
  .v-input__slot {
    padding: 0 16px;
  }
  .v-input {
    width: 100%;
  }
  .v-label {
    margin-bottom: 0;
  }
}
</style>

<style lang="scss" scoped>
@import "@/scss/_breakpoints.scss";

.option-list {
  position: relative;
  min-width: fit-content;
  height: 50px;

  @include for-size(small-tablets-only-or-landscape) {
    height: 40px;
  }

  .selected-option {
    background: #FFFFFF;
    border: 2px solid #D1D1D1;
    border-radius: 25px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    font-size: 18px;
    cursor: pointer;
    color: #9F9F9F;
    position: absolute;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    &:after {
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 6px 6px 0 6px;
      border-color: #8f8f8f transparent transparent transparent;
    }

    @include for-size(small-tablets-only-or-landscape) {
      box-shadow: -2px -2px 2px rgba(0, 0, 0, 0.05), 2px 2px 2px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      border: none;
    }
  }
  .options {
    width: 100%;
    background: #fff;
    box-shadow: 0 5px 5px -3px rgba(0,0,0,.2),
    0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
    border-radius: 2px;
    position: absolute;
    z-index: 1000;
    top: 0;
    &-item {
      height: 48px;
      display: flex;
      align-items: center;
      font-size: 16px;
      cursor: pointer;
      &:hover {
        background: rgba(0,0,0,.04);
      }
    }
  }
}
</style>
